
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="interventions"
      :items-per-page="10"
      class="elevation-1 intervention-table-layout"
      hide-default-footer
      disable-sort
      disable-filtering
      disable-pagination
      @click:row="goToIntervention"
    >
      <template v-slot:item.displayNum="{ item }">
        #{{ item.displayNum }}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="status ellipsis" :style="{ 'background-color' : item.status.color, color: statusFontColor(item.status) }">
          {{ item.status.name }}
        </div>
      </template>
      <template v-slot:item.maker="{ item }">
        {{ item.maker.name }}
      </template>
      <template v-slot:item.client="{ item }">
        {{ item.client.name }}
      </template>
      <template v-slot:item.site="{ item }">
        {{ item.site.$label }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ item.$updatedAt }}
      </template>
      <template v-slot:item.indicators="{ item }">
        <v-row no-gutters align="center" justify="end">
          <div class="indicator-item">
            <v-icon>attach_file</v-icon>
            <div class="indicator-number">{{ item.nbFiles }}</div>
          </div>
          <div class="indicator-item">
            <v-icon>chat_bubble_outline</v-icon>
            <div class="indicator-number">{{ item.nbComments }}</div>
          </div>
        </v-row>
      </template>
    </v-data-table>
    <pager @change="changePager()" class="mt-6" />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import Pager from '@/components/Interventions/Pager.vue';

export default {
  name: `InterventionsTableLayout`,

  components: {
    Pager,
  },

  data: () => ({
  }),

  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/interventions`, {
      challengingInterventions: `challengingList`,
      domains: state => _.sortBy(state.domains || [], domain => _.toLower(domain.name)),
    }),
    ...mapState(`ui/interventions`, {
      interventions: state => state.list.map(intervention => {
        const { site } = intervention;
        const $createdAt = moment(intervention.createdAt).format(`DD/MM/YYYY [à] HH[h]mm`);
        const $updatedAt = moment(intervention.updatedAt).format(`DD/MM/YYYY [à] HH[h]mm`);
        const $refLabel = site.ref && site.ref.length ? ` (Ref: ${site.ref})` : ``;

        return {
          ...intervention,
          $createdAt,
          $updatedAt,
          $address: _.trim(`${site.address || ``} ${site.postalCode || ``} ${site.city || ``}`).replace(/ +/g, ` `),
          site: {
            ...site,
            $label: `${site.name}${$refLabel}`,
          },
        };
      }),
    }),
    ...mapGetters(`model/intervention`, [
      `statusFontColor`,
    ]),
    headers() {
      const headers = [
        {
          text: `ID`,
          align: `start`,
          sortable: false,
          value: `displayNum`,
          class: `header-id`,
          cellClass: `cell-id ellipsis`,
        },
        {
          text: `Statut`,
          value: `status`,
          class: `header-status`,
          cellClass: `cell-status`,
        },
        {
          text: `Titre`,
          value: `title`,
          cellClass: `font-weight-bold`,
        },
        {
          text: `Site`,
          value: `site`,
          class: `header-site`,
          cellClass: `cell-site ellipsis`,
        },
      ];

      if (this.company.isRoot) {
        headers.push({
          text: `Client`,
          value: `client`,
          class: `header-client`,
          cellClass: `cell-client ellipsis`,
        });
      } else {
        headers.push({
          text: `Prestataire`,
          value: `maker`,
          class: `header-maker`,
          cellClass: `cell-maker ellipsis`,
        });
      }

      headers.push({
        text: `Modifiée le`,
        value: `updatedAt`,
        cellClass: `cell-updated-at`,
      });

      headers.push({
        text: ``,
        value: `indicators`,
        cellClass: `cell-indicators`,
      });

      return headers;
    },
  },

  methods: {
    goToIntervention(intervention) {
      if (this.interventionId && this.interventionId === intervention.id) {
        return;
      }

      this.$router.push({
        name: `InterventionsIntervention`,
        params: {
          interventionId: intervention.id,
        },
      });
    },
    changePager() {
      this.$emit(`pager:change`);
    },
  },

  created() {},
};
</script>

<style lang="scss">
.v-data-table.intervention-table-layout {
  $status-width: 120px;
  $maker-client-width: 160px;
  $site-width: 250px;
  $updated-at-width: 160px;

  table > tbody > tr {
    cursor: pointer;
  }

  & > .v-data-table__wrapper > table > thead > tr > th.header-id,
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-id {
    width: 120px;
    max-width: 120px;
  }
  & > .v-data-table__wrapper > table > thead > tr > th.header-status,
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-status {
    width: $status-width;
    max-width: $status-width;
    padding: 0;
  }
  & > .v-data-table__wrapper > table > thead > tr > th.header-maker,
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-maker,
  & > .v-data-table__wrapper > table > thead > tr > th.header-client,
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-client {
    width: $maker-client-width;
    max-width: $maker-client-width;
    padding: 0;
  }
  & > .v-data-table__wrapper > table > thead > tr > th.header-site,
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-site {
    width: $site-width;
    max-width: $site-width;
  }
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-updated-at {
    width: $updated-at-width;
    max-width: $updated-at-width;
    padding: 0 8px 0 12px;
  }
  & > .v-data-table__wrapper > table > tbody > tr > td.cell-indicators {
    width: 120px;
    max-width: 120px;
    padding: 0 16px 0 12px;
    .indicators {
      height: 100%;
      & > .row {
        height: 100%;
      }
    }
    .indicator-item {
      &:not(:last-child) {
        margin-right: 14px;
      }
      .v-icon {
        margin-top: -1px;
        font-size: 1rem;
        margin-right: 3px;
        opacity: .6;
      }
    }
    .indicator-number {
      display: inline-block;
      font-size: 1rem;
      font-weight: 500;
      color: #111;
    }
  }
  .status {
    $height: 25px;
    $font-size: 12px;
    $border-radius: 12px;
    text-align: center;
    height: $height;
    line-height: $font-size;
    border-radius: $border-radius;
    font-size: $font-size;
    font-weight: 500;
    margin: 0;
    padding: ($height/2 - $font-size/2) $border-radius*0.75 8px;
  }
}
</style>
